




























































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import Loading from "../general/Loading.vue";

import ModulesJson from "../../shared/ModulesJson";
import UserJson, { defaultUserJson } from "../../shared/UserJson";

import SettingsUserDetails from "./SettingsUserDetails.vue";
import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "SettingsUsers",
  components: {
    Loading,
    TableView,
    SettingsUserDetails,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    allActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      showUserDetails: false,
      UserPermissionRank: UserPermissionRank,
      UserPermissionRankNames: UserPermissionRankNames,
      searchString: "",
      allUsers: null as UserJson[] | null,
      selectedUserId: null as number | null,
      selectedUser: null as UserJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleUserDetails: function () {
      this.showUserDetails = !this.showUserDetails;
      if (this.showUserDetails == false) {
        this.loadData();
      }
    },

    async loadData() {
      this.allUsers = null;
      if (this.restClient != null) {
        try {
          this.allUsers = await this.restClient.getUsers();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    permissionAble: function (item: UserJson) {
      if (
        this.loginPermission > item.permissionRank ||
        this.loginPermission == this.UserPermissionRank.admin ||
        this.loginId == item.ID
      ) {
        return true;
      } else {
        return false;
      }
    },

    openUserDetails(item: UserJson, mode: string) {
      if (item != null) {
        this.selectedUser = JSON.parse(JSON.stringify(item));
      } else {
        this.selectedUser = { ...defaultUserJson() };
      }

      this.detailsMode = mode;
      this.toggleUserDetails();
    },

    changeLoginData(loginName: string | null, loginPermission: number | null, loginPassword: string | null) {
      this.$emit("change-login-data", loginName, loginPermission, loginPassword);
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openUserDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openUserDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    userColumns: function (): TableViewColumnDefinitions<UserJson>[] {
      let vue = this;

      return [
        {
          th: "Name",
          td: (i) => i.lastName + ", " + i.firstName,
        },
        {
          th: "E-Mail",
          td: (i) => i.email,
        },
        {
          th: "Rolle",
          td: (i) => vue.UserPermissionRankNames[i.permissionRank],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<UserJson>[];
    },

    filteredAllUsers(): UserJson[] | undefined {
      if (this.allUsers != null) {
        var users: UserJson[] = this.allUsers as UserJson[];

        var tokens = this.searchString
          .split(" ")
          .map((t) => t.trim().toLowerCase())
          .filter((t) => t.length > 0);

        for (var token of tokens) {
          users = users.filter(
            (i) => i.firstName.toLowerCase().includes(token) || i.lastName.toLowerCase().includes(token)
          );
        }

        //DEMO: must removed
        //users = users.filter((i) => !i.firstName.includes("Julian") && !i.firstName.includes("Phil"));

        return users;
      }
    },
  },
});
